import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { BaseMapItem } from "./BaseMapItem";
import { BasemapSelector, ICustomBaseMap } from "./BasemapWidget";
import { useBaseMapContext } from "../../Contexts/BaseMapContext";
import { useMapContext } from "../../Contexts/MapContext";
import "./BasemapsSelectorPopup.scss";

export const BasemapsSelectorPopup = (): JSX.Element => {
    const { configA } = useMapContext();
    const { primaryMapId, onOverlayMapClosed } = useBaseMapContext();

    const [maxWidth, setMaxWidth] = useState<number>();

    const popupRef = useRef<HTMLDivElement>();

    useEffect(() => {
        document.addEventListener("mousedown", onClickOutside);
        window.addEventListener("resize", onWindowResize);
        onWindowResize();
        return () => {
            document.removeEventListener("mousedown", onClickOutside);
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    const onWindowResize = () =>
        //width decreased for case, when display height < 430px and map gallery is moved to right, to avoid toolbar overlap
        setMaxWidth(window.innerHeight < 431 ? window.innerWidth - 142 : window.innerWidth - 96);

    const onClickOutside = (event: MouseEvent | PointerEvent) => {
        const childPopup = document.getElementsByClassName("child-maps-popup")[0];
        const isChildPopupClicked = childPopup && childPopup.contains(event.target as Node);

        popupRef.current &&
            !isChildPopupClicked &&
            !popupRef.current.contains(event.target as Node) &&
            onOverlayMapClosed();
    };

    return (
        <div className="overlay-maps-popup" ref={popupRef}>
            <div className="overlay-map-selector">
                {configA.basemaps.length === 1 ? null : (
                    <div className="map-container-overflow-body" style={{ maxWidth }}>
                        {configA.basemaps.map(
                            (basemap: ICustomBaseMap) =>
                                basemap.id !== "WhiteMap" &&
                                ((basemap.childMaps.length > 0 && basemap.parentId === "") ||
                                    (basemap.parentId === "" && basemap.id !== primaryMapId)) && (
                                    <Item key={"child" + basemap.id} basemap={basemap} />
                                )
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const overlayBasemapSelectors: BasemapSelector[] = [];

const getSelectedMapId = (basemap: ICustomBaseMap) => {
    const bmap = overlayBasemapSelectors.filter((val) => val.basemapId === basemap.id)[0];
    if (!bmap) {
        overlayBasemapSelectors.push({
            basemapId: basemap.id,
            selectedMapId: basemap.id
        });
        return basemap.id;
    }
    return bmap.selectedMapId;
};

const Item = ({ basemap }) => {
    return (
        <BaseMapItem
            id={basemap.id + "-child"}
            basemap={basemap}
            classNameDefault={"overlay-map"}
            classNameSelected={"overlay-map-selected"}
            selectedMapId={getSelectedMapId(basemap)}
        />
    );
};
